"use strict";var IObject=require("./_iobject"),defined=require("./_defined");module.exports=function(e){return IObject(defined(e))};